import { v4 as uuidv4 } from "uuid";
// import authService from "../../services/authService.js";

import apiSoapDB from "../../api/soapdb";
import { parseDateOrToday } from "../../helpers";
import { extractTransactionSpecificDetails } from "../../cashhelpers";

export default {
  namespaced: true,

  state: {
    // startDate: new Date(),
    // currentOpeningBalanceEntries: [],
    // currentActivityEntries: [],
    // cashPositionAccounts: [],
  },

  getters: {
    // currentOpeningBalanceEntries(state) {
    //   return state.currentOpeningBalanceEntries;
    // },
    // currentActivityEntries(state) {
    //   return state.currentActivityEntries;
    // },
    // cashPositionAccounts(state) {
    //   return state.cashPositionAccounts;
    // },
  },

  mutations: {
    // setCurrentOpeningBalanceEntries(state, balanceEntries) {
    //   state.currentOpeningBalanceEntries = balanceEntries;
    // },
    // setCurrentActivityEntries(state, activityEntries) {
    //   state.currentActivityEntries = activityEntries;
    // },
    // setCashPositionAccounts(state, accounts) {
    //   state.cashPositionAccounts = accounts;
    // },
  },

  actions: {
    async getGenericListOfAccounts({ state, commit, dispatch, getters, rootGetters }) {
      return new Promise((resolve, reject) => {
        const dbService = rootGetters["localdb/dbService"];
        //MAKE SURE WE HAVE LOCAL DB SERVICE?
        if (!dbService) {
          reject("NO DB SERVICE!");
          return false;
        }

        let accountsQuery = `select * FROM TAccount_Services where active = 'Y' and (service like "%CASH_RECON_BALANCE%" or service like "%CASH_RECON_ITEMS%") order by entity,currency,acctCode`;
        let stmtResp = dbService.prepareStatementQuery(accountsQuery);
        let accountList = [];

        while (stmtResp.step()) {
          //BUILDING ACCOUNT GROUPS & PARSING ACCOUNT IDs DEPENDING ON GROUP TYPE (NO IDEA WHY THERE'S A DIFFERENCE)
          let curAccount = stmtResp.getAsObject();
          curAccount[
            "displayText"
          ] = `${curAccount.entity} - ${curAccount.currency} - ${curAccount.acctCode}`;
          accountList.push(curAccount);
        }

        // commit("setCashPositionAccounts", accountList);
        resolve(accountList);
      });
    },

    async getOpeningBalances(
      { commit, getters, rootGetters },
      { accountId, startDate = null, daysOut = 7 }
    ) {
      return new Promise((resolve, reject) => {
        apiSoapDB
          .doGetCashPositionOpeningBalances(accountId, startDate, daysOut)
          .then((balEntries) => {
            // commit("setCurrentOpeningBalanceEntries", balEntries);
            resolve(balEntries);
          })
          .catch((err) => {
            console.log(err);
            reject(err);
          });
      });
    },
  },
};
